import React from "react";
import "../main.scss"

const BackgroundText = () => {
  // Create a shorter repeated text pattern
  const text = "BELIEVE IN SOMETHING PLS369 ";
  const rowLength = 10; // Number of texts per row
  const numRows = 50; // Number of rows

  return (
    <div className="background-text-overlay">
      <div className="scrolling-wrapper">
        {Array(numRows).fill(null).map((_, rowIndex) => (
          <div 
            key={rowIndex} 
            className="text-row"
            style={{
              display: 'flex',
              whiteSpace: 'nowrap',
              // Offset each row's starting position
              transform: `translateX(${rowIndex % 2 ? '-50%' : '0%'})`,
            }}
          >
            {/* Double the text in each row to ensure smooth infinite scrolling */}
            {Array(rowLength * 2).fill(text).map((text, index) => (
              <div
                key={index}
                style={{
                  color: "rgba(0, 0, 0, 0.35)",
                  fontSize: "2rem",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                  padding: "1rem",
                  userSelect: "none",
                }}
              >
                {text}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BackgroundText;